export function getVariantOfGamePage(page) {
  const variant = page[`game${page.game}`];
  return variant || 'standard';
}
